import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import InstallPrompt from "./components/InstallPrompt";
import { usePageTracking } from "./hooks/useAnalytics";

// Pages
import LandingPage from "./pages/LandingPage";
import InformationHub from "./pages/InformationHub";
import GuideDetail from "./pages/GuideDetail";
import ServiceConnect from "./pages/ServiceConnect";
import ServiceProfile from "./pages/ServiceProfile";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPage from "./pages/PrivacyPage";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <SiteProvider>
            <AuthProvider>
              <div className="App">
                <BrowserRouter>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/guides" element={<InformationHub />} />
                    <Route path="/guides/:slug" element={<GuideDetail />} />
                    <Route path="/services" element={<ServiceConnect />} />
                    <Route path="/services/:slug" element={<ServiceProfile />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/*" element={<AdminDashboard />} />
                  </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
                <InstallPrompt />
              </div>
            </AuthProvider>
          </SiteProvider>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
